import { render, staticRenderFns } from "./DxViewWorkOrderAttachmentMachinaryTable.vue?vue&type=template&id=0b769f30&"
import script from "./DxViewWorkOrderAttachmentMachinaryTable.vue?vue&type=script&lang=js&"
export * from "./DxViewWorkOrderAttachmentMachinaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports